import React from 'react'
import AutoLogin from './autoLogin'

const Index = (props) => {
    return (
        <AutoLogin {...props}></AutoLogin>
    )
}

export default Index
